import React, { useState, useEffect } from "react";
import "./DogMeat.css";
import { useStateValue } from "./StateProvider";
import { holes } from "./CourseInfoOld";

function DogMeat({ id }) {
  const [{ hole }] = useStateValue();
  const [{ dogmeat }, dispatch4] = useStateValue();
  const [won, setWon] = useState();

  useEffect(() => {
    localStorage.setItem("dogmeat", JSON.stringify(dogmeat));
  }, [dogmeat]);

  useEffect(() => {
    const winner = dogmeat?.find((p) => p.hole === hole);
    setWon(winner?.id ? winner?.id : "");
  }, [hole, dogmeat]);

  const saveDM = () => {
    setWon(id);
    dispatch4({
      type: "SAVEDOGMEAT",
      dogmeat: {
        id: id,
        hole: hole,
      },
    });
  };

  const styleSaved = () => {
    return won === id
      ? { color: "black", backgroundColor: "lightgreen" }
      : { backgroundColor: "lightgoldenrodyellow" };
  };

  //show only on par 3's
  if (holes[hole].par > 3) {
    return null;
  } else {
    return (
      <div className="dogmeat">
        <button
          style={styleSaved()}
          className="dogmeat__button"
          type="button"
          onClick={saveDM}
        >
          Dog Meat
        </button>
      </div>
    );
  }
}

export default DogMeat;
